/* Decor Walay — products-bento.js */
document.addEventListener('DOMContentLoaded', function () {
  Array.prototype.slice.call(document.querySelectorAll('.products-bento')).forEach(function (section) {
    var tabs   = Array.prototype.slice.call(section.querySelectorAll('[data-bento-tab]'));
    var panels = Array.prototype.slice.call(section.querySelectorAll('[data-bento-panel]'));
    if (!tabs.length) return;

    function activateTab(targetTab) {
      var key = targetTab.getAttribute('data-bento-tab');
      tabs.forEach(function (t) {
        var active = t === targetTab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-bento-panel') === key);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { activateTab(tab); });
    });

    /* Make sure first tab + panel are active on load */
    if (tabs[0]) activateTab(tabs[0]);
  });
});
